import React from "react";

const Mark = ({ size = 60, color = "#000" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="40" stroke={color} strokeWidth="2" fill="none" />
    <circle cx="50" cy="50" r="10" stroke={color} strokeWidth="2" fill="none" />
    <line x1="50" y1="0" x2="50" y2="100" stroke={color} strokeWidth="2" />
    <line x1="0" y1="50" x2="100" y2="50" stroke={color} strokeWidth="2" />
  </svg>
);

export default Mark;
